import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`mx-auto p-6 flex flex-col items-center justify-center max-w-full min-w-0 box-border`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`w-40 h-10 mb-8`}
`;

const TableContainer = styled.div`
  ${tw`overflow-x-auto shadow-card rounded-lg w-full`}
`;

const TableSkeleton = styled.div`
  ${tw`min-w-full divide-y divide-border-default bg-white`}
`;

const TableHeader = styled.div`
  ${tw`bg-bg-secondary`}
`;

const HeaderRow = styled.div`
  ${tw`grid grid-cols-11 gap-1`}
`;

const HeaderCell = styled(Skeleton)`
  ${tw`h-10 m-2`}
`;

const TableBody = styled.div`
  ${tw``}
`;

const BodyRow = styled.div`
  ${tw`grid grid-cols-11 gap-1 border-b border-border-default`}
`;

const BodyCell = styled(Skeleton)`
  ${tw`h-6 m-3`}
`;

const ButtonContainer = styled.div`
  ${tw`flex justify-center w-full mt-6`}
`;

const ButtonSkeleton = styled(Skeleton)`
  ${tw`w-40 h-10`}
`;

const LocationsPageSkeleton: React.FC = () => {
  return (
    <Container>
      <TitleSkeleton />

      <TableContainer>
        <TableSkeleton>
          <TableHeader>
            <HeaderRow>
              {/* 11 columns based on the original table */}
              {Array(11)
                .fill(0)
                .map((_, i) => (
                  <HeaderCell key={`header-${i}`} />
                ))}
            </HeaderRow>
          </TableHeader>

          <TableBody>
            {/* Display 5 skeleton rows */}
            {Array(5)
              .fill(0)
              .map((_, rowIndex) => (
                <BodyRow key={`row-${rowIndex}`}>
                  {Array(11)
                    .fill(0)
                    .map((_, cellIndex) => (
                      <BodyCell
                        key={`cell-${rowIndex}-${cellIndex}`}
                        width={cellIndex === 1 ? '90%' : '80%'}
                      />
                    ))}
                </BodyRow>
              ))}
          </TableBody>
        </TableSkeleton>
      </TableContainer>

      <ButtonContainer>
        <ButtonSkeleton />
      </ButtonContainer>
    </Container>
  );
};

export default LocationsPageSkeleton;
